export enum CarouselMode {
    VIEWPORT = 'viewport',
    CAROUSEL = 'carousel',
}

export enum CarouselDirection {
    LEFT_TO_RIGHT = 'ltr',
    RIGHT_TO_LEFT = 'rtl',
    TOP_TO_BOTTOM = 'ttb',
    BOTTOM_TO_TOP = 'btt',
}

export enum CarouselAlignment {
    START = 'start',
    END = 'end',
    CENTER = 'center',
    CENTER_ODD = 'center-odd',
    CENTER_EVEN = 'center-even',
}

export interface ThresholdConfig {
    threshold: number;
}

export interface CarouselI18nConfig {
    ariaGallery: string;
    ariaNavigateToSlide: string;
    ariaNextSlide: string;
    ariaPreviousSlide: string;
    iconArrowDown: string;
    iconArrowLeft: string;
    iconArrowRight: string;
    iconArrowUp: string;
    itemXofY: string;
}

export interface CarouselConfig {
    autoplay: number;
    breakpointMode: CarouselMode;
    breakpoints: Record<number, Partial<Omit<CarouselConfig, 'breakpoints' | 'breakpointMode'>>>;
    clamp: boolean;
    dir: CarouselDirection;
    enabled: boolean;
    gap: number;
    height: number | string;
    i18n: CarouselI18nConfig;
    ignoreAnimations: boolean | string | Array<string>;
    itemsToScroll: number;
    itemsToShow: number | 'auto';
    modelValue: number;
    mouseDrag: boolean | ThresholdConfig;
    mouseWheel: boolean | ThresholdConfig;
    pauseAutoplayOnHover: boolean;
    preventExcessiveDragging: boolean;
    slideEffect: 'slide' | 'fade';
    snapAlign: CarouselAlignment;
    touchDrag: boolean | ThresholdConfig;
    transition: number;
    transitionEasing: string;
    wrapAround: boolean;
}